import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signInWithPopup, signOut } from 'firebase/auth';
import { auth, googleProvider, ADMIN_EMAIL } from '../firebase';
import { ShieldCheck, Loader2, LogIn, AlertTriangle } from 'lucide-react';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  // Si ya hay un admin logueado, ir directo al panel.
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      if (u && u.email === ADMIN_EMAIL) {
        navigate('/admin', { replace: true });
      } else {
        setCargando(false);
      }
    });
    return () => unsub();
  }, [navigate]);

  const entrar = async () => {
    setError(null);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      if (result.user.email !== ADMIN_EMAIL) {
        await signOut(auth);
        setError('Esta cuenta no está autorizada como administrador.');
        return;
      }
      navigate('/admin', { replace: true });
    } catch (err) {
      console.error('Error de login admin:', err);
      if (err.code !== 'auth/popup-closed-by-user') {
        setError('No se pudo iniciar sesión. Intenta de nuevo.');
      }
    }
  };

  if (cargando) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <Loader2 className="animate-spin text-blue-500" size={32} />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <div className="w-full max-w-sm bg-slate-800/60 backdrop-blur-sm border border-slate-700/60 rounded-3xl p-7 shadow-2xl text-center">
        <div className="w-14 h-14 rounded-2xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center mx-auto mb-4">
          <ShieldCheck className="text-emerald-400" size={28} />
        </div>
        <h1 className="text-xl font-bold text-white">Acceso administrador</h1>
        <p className="text-slate-400 text-sm mt-1 mb-6">Inicia sesión para configurar el chat.</p>

        <button
          onClick={entrar}
          className="w-full bg-white hover:bg-slate-100 text-slate-800 font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-colors"
        >
          <LogIn size={18} />
          Continuar con Google
        </button>

        {error && (
          <div className="mt-4 p-3 rounded-xl bg-red-500/10 border border-red-500/30 text-red-300 text-xs flex items-center gap-2 justify-center">
            <AlertTriangle size={14} /> {error}
          </div>
        )}
      </div>
    </div>
  );
}
